import { render, staticRenderFns } from "./RemolquePivotTable.vue?vue&type=template&id=0062e642"
import script from "./RemolquePivotTable.vue?vue&type=script&lang=js"
export * from "./RemolquePivotTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports